
import { useState, useEffect } from 'react';

export interface DashboardAnalyticsData {
  referralStats: {
    total: number;
    pending: number;
    approved: number;
    completed: number;
  };
  monthlyActivity: Array<{
    month: string;
    sent: number;
    approved: number;
  }>;
}

export const useAdminDashboardAnalytics = () => {
  const [analyticsData, setAnalyticsData] = useState<DashboardAnalyticsData>({
    referralStats: {
      total: 0,
      pending: 0,
      approved: 0,
      completed: 0
    },
    monthlyActivity: []
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      setIsLoading(true);
      try {
        // In a real app, this would be an API call
        // For demo purposes, we're using mock data
        
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // Mock data that's properly formatted
        const mockData: DashboardAnalyticsData = {
          referralStats: {
            total: 245,
            pending: 68,
            approved: 142,
            completed: 35
          },
          monthlyActivity: [
            { month: 'Jan', sent: 28, approved: 15 },
            { month: 'Feb', sent: 35, approved: 22 },
            { month: 'Mar', sent: 42, approved: 28 },
            { month: 'Apr', sent: 38, approved: 24 },
            { month: 'May', sent: 45, approved: 31 },
            { month: 'Jun', sent: 56, approved: 38 }
          ]
        };
        
        setAnalyticsData(mockData);
      } catch (error) {
        console.error('Error fetching analytics data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchAnalyticsData();
  }, []);

  return {
    analyticsData,
    isLoading
  };
};

export default useAdminDashboardAnalytics;
